import { useAtom } from 'jotai';
import React from 'react'
import { projectAtomList } from '../atoms';

const DownloadConfiguration = ({isOpen,programType, 
  handleSerialNoPopUp,
  downloadHMI,
  downloadMOXA,
  downloadFortiGate,
  downloadCONNEXIUM,
  downloadIpcFile,
  downloadDeployPackage,
   onClose, title, uploadedPackage,deleteUploadPackage}) => {
      const [currentProject, setCurrentProject] = useAtom(projectAtomList);
  return (
    <se-dialog
            id="dialog-simple-site-created"
            color="alternative"
            size="large"
            open={isOpen}
            can-backdrop="false"
          >
            <se-dialog-header color="primary">{`Download ${title} Program`} </se-dialog-header>
            <se-dialog-content>
                <div className="table-responsive">
            <table className="table table-bordered mb-0">
              <thead>
                <tr align="center">
                  <th>S.no.</th>
                  <th>Document Name</th>
                  <th>Description</th>
                  <th>Uploaded By</th>
                  <th>Uploaded On</th>
                 
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                  <tr align="center">
                    <td width="10%">1.</td>
                    <td width="25%">{currentProject?.projectStatus?.projectName + `${
                      programType?.packageType === "PLC"
                      ?"_EMOM"
                      :programType?.packageType ==="IPC"
                      ?"_EMA"
                      :programType?.packageType === "HMI"
                      ?"_HMI"
                      :programType?.packageType === "MOXA"
                      ?"_MOXA"
                      :"_ConneXium"
                      }` }</td>
                    <td width="10%">Original package</td>
                    <td width="10%">NA</td>
                    <td width="10%">NA</td>
                    
                    <td width="10%">
                      <se-icon
                        size="small"
                        color="primary"
                        style={{ cursor: "pointer" }}
                        onClick={()=>{
                          programType?.packageType === "PLC"
                          ? handleSerialNoPopUp("PLC")
                          :programType?.packageType ==="IPC"
                          ? downloadIpcFile()
                          :programType?.packageType === "HMI"
                          ? downloadHMI()
                          :programType?.packageType === "MOXA"
                          ? downloadMOXA()
                          :programType?.packageType === "FortiGate"
                          ? downloadFortiGate()
                          :downloadCONNEXIUM()
                         
                          onClose();
                        }}
                      >
                        action_download_stroke
                      </se-icon>
                    </td>
                  </tr>
                {uploadedPackage && <tr align="center">
                    <td width="10%">2.</td>
                    <td width="25%">{uploadedPackage?.documentName}</td>
                    <td width="10%">{uploadedPackage?.description}</td>
                    <td width="10%">{uploadedPackage?.uploadedBy?.firstName}</td>
                    <td width="10%">{uploadedPackage?.uploadedOn}</td>
                    
                    <td width="10%">
                      <se-icon
                        size="small"
                        color="primary"
                        style={{ cursor: "pointer", marginRight:"2px" }}
                        onClick={()=>{
                          downloadDeployPackage(uploadedPackage?.uploadType, uploadedPackage?.id, uploadedPackage?.documentName);
                          onClose();
                        }}
                      >
                        action_download_stroke
                      </se-icon>
                      <se-icon
                        size="small"
                        color="primary"
                        style={{ cursor: "pointer" }}
                        onClick={()=>{
                          deleteUploadPackage(uploadedPackage?.uploadType, uploadedPackage?.id);
                          onClose();
                        }}
                      >
                        action_delete_stroke
                      </se-icon>
                    </td>
                  </tr>}
              </tbody>
            </table>
            </div>
            </se-dialog-content>
            <se-dialog-footer>
          <se-button onClick={onClose}>Cancel</se-button>
          
        </se-dialog-footer>
          </se-dialog>
  )
}

export default DownloadConfiguration
